// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jr-tile {
  border: 1px solid #000;
  padding: 10px 12px 12px;
  margin: 0 0 10px 0;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  color: #222;
}
.jr-tile .header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 2px;
}
.jr-tile .left {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  min-width: 0;
}
.jr-tile .status-marker {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex: 0 0 auto;
}
.jr-tile .title {
  flex: 1 1 0;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 1rem;
  text-decoration: underline;
  padding: 0;
  line-height: 1.15;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.jr-tile .name {
  font-weight: 700;
  margin-right: 4px;
  white-space: nowrap;
}
.jr-tile .desc {
  color: #3c3c3c;
  font-size: 0.96rem;
  white-space: nowrap;
}
.jr-tile .edit-button {
  flex: 0 0 auto;
  border: none;
  background: transparent;
  color: #222;
  font-size: 18px;
  line-height: 1;
  padding: 0 2px;
  cursor: pointer;
  margin-left: 4px;
}
.jr-tile .edit-button mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  line-height: 18px;
}
.jr-tile .icon {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  padding: 2px 4px;
  color: #222;
}
.jr-tile .icon:hover {
  color: #c00;
}
.jr-tile .actions {
  flex: 0 0 auto;
}
.jr-tile .shipped-indicator {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-right: 8px;
  margin-bottom: 0;
  font-size: 0.92rem;
  color: #666;
  white-space: nowrap;
}
.jr-tile .shipped-indicator input[type=checkbox] {
  width: 14px;
  height: 14px;
  margin: 0;
  accent-color: #c9c9c9;
}
.jr-tile .conclusion {
  font-weight: 600;
  margin: 4px 0 6px;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.01em;
}
.jr-tile .detail-row {
  display: flex;
  gap: 6px;
  margin: 2px 0;
  font-size: 0.95rem;
  align-items: baseline;
}
.jr-tile .label {
  font-weight: 600;
  white-space: nowrap;
  flex: 0 0 auto;
}
.jr-tile .value {
  flex: 1;
}
.jr-tile .material-section {
  margin: 6px 0 4px;
  font-size: 0.9rem;
}
.jr-tile .material-title {
  font-weight: 600;
  margin-bottom: 4px;
}
.jr-tile .test-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
  margin-bottom: 2px;
}
.jr-tile .test-group-label {
  font-size: 0.9rem;
  white-space: nowrap;
}
.jr-tile .test {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-right: 4px;
}
.jr-tile .status-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex: 0 0 auto;
}
.jr-tile .test-title {
  font-size: 0.9rem;
  white-space: nowrap;
}
.jr-tile .status-pass {
  background-color: #28a745;
}
.jr-tile .status-fail {
  background-color: #dc3545;
}
.jr-tile .status-pending {
  background-color: #ffc107;
}
.jr-tile .status-unknown {
  background-color: #6c757d;
}
.jr-tile .properties {
  display: flex;
  gap: 18px;
  margin: 8px 0 6px;
}
.jr-tile .prop-col {
  flex: 1;
}
.jr-tile .cutback-properties .prop-col {
  flex: 1 1 100%;
}
.jr-tile .cutback-properties .prop-col:last-child {
  display: none;
}
.jr-tile .checkboxes {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 8px 0 6px;
}
.jr-tile .checkbox-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.9rem;
  cursor: pointer;
}
.jr-tile .checkbox-label input[type=checkbox] {
  cursor: pointer;
}
.jr-tile .checkbox-label input[disabled] {
  cursor: default;
}
.jr-tile .footer {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
  align-items: center;
  justify-content: flex-start;
}
.jr-tile .btn {
  padding: 6px 10px;
  font-size: 0.95rem;
  cursor: pointer;
  border-radius: 0;
  font-weight: 400;
  min-width: auto;
}
.jr-tile .btn-sm {
  padding: 2px 8px;
  font-size: 0.85rem;
}
.jr-tile .btn-right {
  margin-left: auto;
}
.jr-tile .footer .btn:not(.btn-right) {
  margin-right: 0;
}
.jr-tile .warning {
  color: #856404;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 0.85rem;
  margin-top: 6px;
}
.jr-tile.cutback-tile {
  padding-top: 10px;
}
.jr-tile.cutback-tile .header {
  margin-bottom: 0;
}
.jr-tile.cutback-tile .title {
  font-size: 1rem;
  max-width: 100%;
}
.jr-tile.cutback-tile .cutback-body {
  padding-top: 0;
}
.jr-tile.cutback-tile .cutback-body > :first-child {
  margin-top: 0;
}
.jr-tile.cutback-tile .conclusion {
  margin-top: 4px;
  margin-bottom: 10px;
  font-size: 1.02rem;
  font-weight: 700;
}
.jr-tile.cutback-tile .detail-row,
.jr-tile.cutback-tile .checkboxes {
  margin-left: 4px;
}
.jr-tile.cutback-tile .detail-row {
  margin: 4px 0;
  font-size: 0.96rem;
  align-items: baseline;
}
.jr-tile.cutback-tile .well-job-row {
  margin-bottom: 15px;
}
.jr-tile.cutback-tile .label {
  min-width: 146px;
}
.jr-tile.cutback-tile .checkboxes {
  margin-top: 8px;
  margin-bottom: 2px;
  min-height: 18px;
}
.jr-tile.cutback-tile .footer {
  gap: 8px;
  margin-top: 6px;
}
.jr-tile.cutback-tile .btn {
  min-width: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-tile/job-request-tile.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AACF;AAEE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;AAAJ;AAGE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;AADJ;AAIE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAFJ;AAKE;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAHJ;AAME;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;AALJ;AAQE;EACE,cAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AANJ;AAQI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AANN;AAUE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;AARJ;AAUI;EAAU,WAAA;AAPd;AAUE;EAAW,cAAA;AAPb;AASE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AAPJ;AASI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,qBAAA;AAPN;AAYE;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;AAVJ;AAcE;EACE,aAAA;EACA,QAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;AAZJ;AAeE;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;AAbJ;AAgBE;EACE,OAAA;AAdJ;AAkBE;EACE,iBAAA;EACA,iBAAA;AAhBJ;AAmBE;EACE,gBAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,iBAAA;EACA,mBAAA;AAnBJ;AAsBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AApBJ;AAuBE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AArBJ;AAwBE;EACE,iBAAA;EACA,mBAAA;AAtBJ;AA0BE;EAAkB,yBAAA;AAvBpB;AAwBE;EAAkB,yBAAA;AArBpB;AAsBE;EAAkB,yBAAA;AAnBpB;AAoBE;EAAkB,yBAAA;AAjBpB;AAoBE;EACE,aAAA;EACA,SAAA;EACA,iBAAA;AAlBJ;AAqBE;EACE,OAAA;AAnBJ;AAuBI;EACE,cAAA;AArBN;AAwBI;EACE,aAAA;AAtBN;AA2BE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;AAzBJ;AA4BE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;AA1BJ;AA4BI;EAAyB,eAAA;AAzB7B;AA0BI;EAAkB,eAAA;AAvBtB;AA2BE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;AAzBJ;AA4BE;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AA1BJ;AA6BE;EACE,gBAAA;EACA,kBAAA;AA3BJ;AA8BE;EACE,iBAAA;AA5BJ;AA+BE;EACE,eAAA;AA7BJ;AAiCE;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA/BJ;AAkCE;EACE,iBAAA;AAhCJ;AAkCI;EACE,gBAAA;AAhCN;AAmCI;EACE,eAAA;EACA,eAAA;AAjCN;AAoCI;EACE,cAAA;AAlCN;AAqCI;EACE,aAAA;AAnCN;AAsCI;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AApCN;AAuCI;;EAEE,gBAAA;AArCN;AAwCI;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;AAtCN;AAyCI;EACE,mBAAA;AAvCN;AA0CI;EACE,gBAAA;AAxCN;AA2CI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AAzCN;AA4CI;EACE,QAAA;EACA,eAAA;AA1CN;AA6CI;EACE,eAAA;AA3CN","sourcesContent":[".jr-tile {\n  border: 1px solid #000;\n  padding: 10px 12px 12px;\n  margin: 0 0 10px 0;\n  width: 100%;\n  box-sizing: border-box;\n  background: #fff;\n  color: #222;\n\n  // --- Header ---\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 10px;\n    margin-bottom: 2px;\n  }\n\n  .left {\n    display: flex;\n    flex: 1 1 auto;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: nowrap;\n    min-width: 0;\n  }\n\n  .status-marker {\n    display: inline-block;\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    flex: 0 0 auto;\n  }\n\n  .title {\n    flex: 1 1 0;\n    background: none;\n    border: none;\n    text-align: left;\n    cursor: pointer;\n    font-size: 1rem;\n    text-decoration: underline;\n    padding: 0;\n    line-height: 1.15;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .name {\n    font-weight: 700;\n    margin-right: 4px;\n    white-space: nowrap;\n  }\n\n  .desc {\n    color: #3c3c3c;\n    font-size: .96rem;\n    white-space: nowrap;\n  }\n\n  .edit-button {\n    flex: 0 0 auto;\n    border: none;\n    background: transparent;\n    color: #222;\n    font-size: 18px;\n    line-height: 1;\n    padding: 0 2px;\n    cursor: pointer;\n    margin-left: 4px;\n\n    mat-icon {\n      width: 18px;\n      height: 18px;\n      font-size: 18px;\n      line-height: 18px;\n    }\n  }\n\n  .icon {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 16px;\n    line-height: 1;\n    padding: 2px 4px;\n    color: #222;\n\n    &:hover { color: #c00; }\n  }\n\n  .actions { flex: 0 0 auto; }\n\n  .shipped-indicator {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin-right: 8px;\n    margin-bottom: 0;\n    font-size: .92rem;\n    color: #666;\n    white-space: nowrap;\n\n    input[type=\"checkbox\"] {\n      width: 14px;\n      height: 14px;\n      margin: 0;\n      accent-color: #c9c9c9;\n    }\n  }\n\n  // --- Conclusion ---\n  .conclusion {\n    font-weight: 600;\n    margin: 4px 0 6px;\n    font-size: 1rem;\n    text-transform: uppercase;\n    letter-spacing: .01em;\n  }\n\n  // --- Detail rows ---\n  .detail-row {\n    display: flex;\n    gap: 6px;\n    margin: 2px 0;\n    font-size: .95rem;\n    align-items: baseline;\n  }\n\n  .label {\n    font-weight: 600;\n    white-space: nowrap;\n    flex: 0 0 auto;\n  }\n\n  .value {\n    flex: 1;\n  }\n\n  // --- Material section ---\n  .material-section {\n    margin: 6px 0 4px;\n    font-size: .9rem;\n  }\n\n  .material-title {\n    font-weight: 600;\n    margin-bottom: 4px;\n  }\n\n  .test-group {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 4px 8px;\n    margin-bottom: 2px;\n  }\n\n  .test-group-label {\n    font-size: .9rem;\n    white-space: nowrap;\n  }\n\n  .test {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    margin-right: 4px;\n  }\n\n  .status-dot {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    flex: 0 0 auto;\n  }\n\n  .test-title {\n    font-size: .9rem;\n    white-space: nowrap;\n  }\n\n  // --- Status colors (shared by marker + dot) ---\n  .status-pass    { background-color: #28a745; }\n  .status-fail    { background-color: #dc3545; }\n  .status-pending { background-color: #ffc107; }\n  .status-unknown { background-color: #6c757d; }\n\n  // --- Two-column properties ---\n  .properties {\n    display: flex;\n    gap: 18px;\n    margin: 8px 0 6px;\n  }\n\n  .prop-col {\n    flex: 1;\n  }\n\n  .cutback-properties {\n    .prop-col {\n      flex: 1 1 100%;\n    }\n\n    .prop-col:last-child {\n      display: none;\n    }\n  }\n\n  // --- Checkboxes ---\n  .checkboxes {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin: 8px 0 6px;\n  }\n\n  .checkbox-label {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: .9rem;\n    cursor: pointer;\n\n    input[type=\"checkbox\"] { cursor: pointer; }\n    input[disabled] { cursor: default; }\n  }\n\n  // --- Footer ---\n  .footer {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 6px;\n    align-items: center;\n    justify-content: flex-start;\n  }\n\n  .btn {\n    padding: 6px 10px;\n    font-size: .95rem;\n    cursor: pointer;\n    border-radius: 0;\n    font-weight: 400;\n    min-width: auto;\n  }\n\n  .btn-sm {\n    padding: 2px 8px;\n    font-size: .85rem;\n  }\n\n  .btn-right {\n    margin-left: auto;\n  }\n\n  .footer .btn:not(.btn-right) {\n    margin-right: 0;\n  }\n\n  // --- Pycnometer warning ---\n  .warning {\n    color: #856404;\n    background: #fff3cd;\n    border: 1px solid #ffc107;\n    border-radius: 4px;\n    padding: 6px 10px;\n    font-size: .85rem;\n    margin-top: 6px;\n  }\n\n  &.cutback-tile {\n    padding-top: 10px;\n\n    .header {\n      margin-bottom: 0;\n    }\n\n    .title {\n      font-size: 1rem;\n      max-width: 100%;\n    }\n\n    .cutback-body {\n      padding-top: 0;\n    }\n\n    .cutback-body > :first-child {\n      margin-top: 0;\n    }\n\n    .conclusion {\n      margin-top: 4px;\n      margin-bottom: 10px;\n      font-size: 1.02rem;\n      font-weight: 700;\n    }\n\n    .detail-row,\n    .checkboxes {\n      margin-left: 4px;\n    }\n\n    .detail-row {\n      margin: 4px 0;\n      font-size: .96rem;\n      align-items: baseline;\n    }\n\n    .well-job-row {\n      margin-bottom: 15px;\n    }\n\n    .label {\n      min-width: 146px;\n    }\n\n    .checkboxes {\n      margin-top: 8px;\n      margin-bottom: 2px;\n      min-height: 18px;\n    }\n\n    .footer {\n      gap: 8px;\n      margin-top: 6px;\n    }\n\n    .btn {\n      min-width: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
